import { AssetDetails, AssetGroup } from "..";

export interface Asset {
  DomainId: string;
  AssetGroupName: string;
  AssetGroupId?: string;
  Detail: AssetDetails;
  Rank: string;
  IsFeaturedAsset?: boolean;
  IsMontage?: boolean;
}